import { Controller } from '@hotwired/stimulus'

export default class extends Controller {

  static targets = [ "tab", "tabPanel", "tabIndexInput" ]

  initialize() {
    this.showTab()
  }

  change(e){
    this.index = this.tabTargets.indexOf(e.target)
    this.showTab(this.index)
  }

  showTab() {
    this.tabPanelTargets.forEach((el, i) => {
      if(i === this.index){
        el.classList.remove('is-hidden')
      } else {
        el.classList.add('is-hidden')
      }
    })

    this.tabTargets.forEach((el, i) => {
      if(i === this.index){
        el.classList.add(this.activeClass)
      } else {
        el.classList.remove(this.activeClass)
      }
    })
  }

  get index() {
    return parseInt(this.data.get('index'))
  }

  get activeClass() {
    return this.data.get('activeClass') || 'tab--active'
  }

  set index(value) {
    this.data.set("index", value)
    if (this.hasTabIndexInputTarget) {
      this.tabIndexInputTarget.value = value
    }
    this.showTab()
  }
}
